var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPauseGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3757",
    "data-name": "Rectangle 3757",
    width: 16,
    height: 16,
    rx: 4,
    fill: "#ababab"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseGrey);
export default __webpack_public_path__ + "static/media/pauseGrey.dca2ef379860de67b1bcbd641e282500.svg";
export { ForwardRef as ReactComponent };